var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { VisuallyHidden } from '../visuallyHidden';
/**
 * A hook that will return a hidden node that will be used to announce loading and loaded states
 */
export function useAriaLiveLoading(_a) {
    var loadedText = _a.loadedText, loading = _a.loading, loadingText = _a.loadingText;
    var hiddenNode = useMemo(function () { return _jsx(VisuallyHidden, __assign({ "aria-live": "polite" }, { children: loading ? loadingText : loadedText })); }, [loadedText, loading, loadingText]);
    return {
        hiddenNode: hiddenNode,
    };
}
useAriaLiveLoading.displayName = 'useAriaLiveLoading';
//# sourceMappingURL=useAriaLiveLoading.js.map